"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _richTextImg = require("../../../../public/js/richTextImg.js");
var _banner = _interopRequireDefault(require("@/components/banner.vue"));
var _search = _interopRequireDefault(require("@/components/search.vue"));
var _nav = _interopRequireDefault(require("@/components/nav.vue"));
require("../index.less");
var _news = require("@/api/news/news");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Banner: _banner.default,
    Search: _search.default,
    Nav: _nav.default
  },
  data: function data() {
    return {
      richContent: '',
      tabList: ['相关资料', '教学团队'],
      curIndex: 0
    };
  },
  methods: {
    tabs: function tabs(i, j) {
      this.curIndex = j;
    },
    toNews: function toNews() {
      this.$router.push({
        path: "/reNews",
        query: {
          curIndex: this.curIndex
        }
      });
    },
    toCom: function toCom() {
      this.$router.push('/competition');
    } // 获取单篇详情
    //   async getSingleInfo () {
    //     try {
    //        const { data: res } = await this.$api.singleInfo(3)
    //        this.single = res
    //        if(this.single.content){
    //          this.richContent = formatRichText(this.single.content);
    //        }
    //     } catch (error) {
    //       console.log(error)
    //     }
    //   },
    // },
  },
  created: function created() {}
};